import { graphQlClient } from '@config/graphqlClient';
import { Material } from '@models/material.model';
import { Equipment } from '@models/equipment.model';
import TasksGraphQL from '@graphql/task.queries';

export interface EmployeesFilter {
  text?: string | null;
  role?: string | null;
  id?: string | null;
  page?: number | null;
  limit?: number | null;
}

export const materialAndEquipmentService = {
  async getMaterialsAndEquipments(projectId: string): Promise<{
    materials: Material[];
    equipments: Equipment[];
  }> {
    const data: any = await graphQlClient.request(
      TasksGraphQL.queries.getAllMaterialsAndEquipments,
      {
        projectId,
      },
    );
    return {
      materials: data?.getAllMaterialsAndEquipments?.materials || [],
      equipments: data?.getAllMaterialsAndEquipments?.equipments || [],
    };
  },
};
